// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__19EqA","dragIcon":"SortableItem_dragIcon__2rKMP","disabled":"SortableItem_disabled__Xrgq0"};